export let baseURL

// Check for explicit API URL from environment variable first
if (process.env.REACT_APP_API_URL) {
	baseURL = process.env.REACT_APP_API_URL
} else if (process.env.REACT_APP_NODE === 'production') {
	baseURL = 'https://loadfetcher.com'
} else {
	baseURL = '' //'http://localhost:5001'
}
